export const BRAND_EXCLUDED_ROUTES = ['/cart', '/checkout'];
